import { Injectable } from '@angular/core';

import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { createFrom, EventService, SiteContextActions } from '@spartacus/core';
import { map } from 'rxjs/operators';

import { DpMarketSetEvent } from './site-context.events';

/**
 * Builds and registers the site context events
 */
@Injectable({
  providedIn: 'root'
})
export class DpSiteContextEventBuilder {
  constructor(
    protected actionsSubject: ActionsSubject,
    protected eventService: EventService
  ) {
    this.registerSetMarket();
  }

  /**
   * Register the market set action
   */
  protected registerSetMarket(): void {
    const marketEvent$ = this.actionsSubject.pipe(
      ofType<SiteContextActions.SetActiveBaseSite>(SiteContextActions.SET_ACTIVE_BASE_SITE),
      map((marketAction) =>
        createFrom(DpMarketSetEvent, {
          activeMarket: marketAction.payload
        })
      )
    );

    this.eventService.register(DpMarketSetEvent, marketEvent$);
  }
}
